import React, { PropsWithChildren, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './SearchRegionSelect.styles';

interface SearchRegionSelectProps {
  isRegionSelected: boolean;
  isDropdownOpen: boolean;
  value: string;
  onClick: () => void;
  onSearch: (value: string) => void;
  onCloseIconClick: () => void;
}

export const SearchRegionSelect: React.FC<
  PropsWithChildren<SearchRegionSelectProps>
> = ({
  isRegionSelected,
  isDropdownOpen,
  value,
  onClick,
  onSearch,
  onCloseIconClick,
  children,
}) => {
  const { t } = useTranslation();
  const inputRef = useRef<HTMLInputElement>(null);

  function handleClick() {
    if (isDropdownOpen) {
      inputRef.current?.blur();
    } else {
      inputRef.current?.focus();
    }

    onClick();
  }

  function handleCloseIconClick(e: React.MouseEvent<SVGSVGElement>) {
    e.stopPropagation();
    onCloseIconClick();
  }

  return (
    <S.SearchRegionSelectWrapper>
      <S.SearchRegionSelectBox
        data-testid="search-region-select-box"
        onClick={handleClick}
      >
        <S.SearchRegionSelectContent>
          {isRegionSelected ? (
            <S.SearchRegionSelectCloseIcon
              data-testid="search-region-select-close-icon"
              onClick={handleCloseIconClick}
            />
          ) : (
            <S.SearchRegionSelectIcon
              data-testid="search-region-select-icon"
              $isDropdownOpen={isDropdownOpen}
            />
          )}
          <S.SearchRegionSelectInput
            data-testid="search-region-select-input"
            ref={inputRef}
            name="searchRegionSelectInput"
            value={value}
            placeholder={t('common.city')}
            onChange={e => onSearch(e.target.value)}
          />
          <S.SearchRegionSelectAngleIcon $isDropdownOpen={isDropdownOpen} />
        </S.SearchRegionSelectContent>
      </S.SearchRegionSelectBox>
      {children}
    </S.SearchRegionSelectWrapper>
  );
};
